module.exports = __webpack_public_path__ + "public/img/在线购买配图.bc595602.png";